export const BUILDING_FORM_ADDITIONAL_FIELDS_COUNT = 4
